export default "__VITE_ASSET__c245a11b__"